import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { container } from "tsyringe";
import ModuleConfig from "configs/ModuleConfig";

const modules = container.resolve(ModuleConfig).get().modules;

export const useNavigateToHomePage = () => {
    const navigate = useNavigate();

    const navigateToHomePage = useCallback(() => {
        navigate(modules.pages.Home.props.path);
    }, [navigate]);

    return {
        navigateToHomePage,
    };
};
